/** @type {import('@knitiv/api-client-javascript').KNode} */
const DEFAULT_NOTE_TYPE = 'K_NODE;KNOTETYPE_note';

export default class NoteComment {
	/**
	 * @param {*} value
	 * @throws {Error}
	 * @returns {void}
	 */
	static set isa(value) {
		throw new Error(`The isa property cannot be written. ${value} was passed.`);
	}

	static get DEFAULT_NOTE_TYPE() {
		return DEFAULT_NOTE_TYPE;
	}

	/** @type {boolean} */
	#edit;

	/** @type {string} */
	#oldContent = '';

	/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
	#oldType;

	/** @type {boolean} */
	#reply;

	/**
	 * @param {any} note
	 */
	constructor(note = null) {
		this.#edit = false;
		this.#oldContent = '';
		this.#oldType = undefined;
		this.#reply = false;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.author = note?.author?.kid ?? note?.author;

		/** @type {string} */
		this.content = note?.content ?? '';

		/** @type {{ created: Date, updated: ?Date}} */
		this.date = {
			created: note?.date?.created ? new Date(note.date.created) : new Date(),
			updated: note?.date?.updated ? new Date(note.date.updated) : null,
		};

		/** @type {'K_NODE;KNOTE'} */
		this.isa = 'K_NODE;KNOTE';

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.kid = note?.kid;

		/** @type {?NoteComment} */
		this.parent = note?.parent ?? null;

		/** @type {NoteComment[]} */
		this.replies = note?.replies?.map((/** @type {NoteComment} */ reply) => new NoteComment(reply)) ?? [];

		/** @type {{create: boolean, update: boolean, delete: boolean}} */
		this.rights = note?.rights ?? {
			create: true,
			update: true,
			delete: true,
		};

		/** @type {import('@knitiv/api-client-javascript').KNode} */
		this.type = note?.type?.kid ?? note?.type ?? NoteComment.DEFAULT_NOTE_TYPE;
	}

	/**
	 * @param {import('./note-comment').default} note
	 */
	addReply(note) {
		this.replies.push(note);
	}

	cancel() {
		this.content = this.#oldContent;
		this.#oldContent = '';
		this.type = this.#oldType ?? NoteComment.DEFAULT_NOTE_TYPE;
		this.#oldType = undefined;
		this.#edit = false;
	}

	edit() {
		this.#oldContent = this.content;
		this.#oldType = this.type;
		this.#edit = true;
		this.#reply = false;
	}

	export() {
		return {
			content: this.content,
			replies: this.replies,
		};
	}

	isEdit() {
		return this.#edit;
	}

	isReply() {
		return this.#reply;
	}

	reply() {
		this.#edit = true;
		this.#reply = true;
	}

	update() {
		this.#oldContent = '';
		this.#oldType = undefined;
		this.#edit = false;
		this.#reply = false;
	}
}
